/// <amd-module name="Wit/Filter/AreaPathFilterProvider" />
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { IFilterProvider } from "Wit/Filter/FilterManager";
import { FieldFilterProvider } from "Wit/Filter/FieldFilterProvider";
import { getAreaPathLeafNode } from "Wit/Filter/AreaPathHelper";

export class AreaPathFilterProvider extends FieldFilterProvider implements IFilterProvider {
    constructor() {
        super(CoreFieldRefNames.AreaPath);
    }

    /**
     * Override for area path match which checks only leaf node
     * @param areaPath
     */
    protected matchesFilter(areaPath: string): boolean {
        const text = getAreaPathLeafNode(areaPath);

        if (text in this._filterValueMap) {
            return true;
        }

        return false;
    }
}
